import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Globals } from '../../common/global';
import { ConfigApi } from '../../config-api';
import { ApiCallingService } from '../../services/api-calling.service';

@Component({
  selector: 'app-vending-donation-master',
  templateUrl: './vending-donation-master.component.html',
  styleUrls: ['./vending-donation-master.component.css']
})
export class VendingDonationMasterComponent implements OnInit {

  donationData: any[] = [];
  page = 1;
  pageSize = 10;
  totalCount = 0;
  loading = false;

  userDetails: any;
  modeltitle = '';
  detail: any = {};
  donationToDelete = '';

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    const data = localStorage.getItem("Auth-user");
    if (data) {
      this.userDetails = JSON.parse(data);
    }
  }

  ngOnInit(): void {
    this.getDonationList();
  }

  getDonationList() {
    this.loading = true;

    this.apiCallingService.callAPI(
      {},
      "GET",
      ConfigApi.URLS.DONATION_MASTER.LIST +
      `?operator_id=${this.userDetails._id}&page=${this.page - 1}&limit=${this.pageSize}`
    ).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.donationData = res.data || [];
          this.totalCount = res.total || 0;
        }
        this.loading = false;
      },
      () => {
        this.toastr.error("Failed to load donations");
        this.loading = false;
      }
    );
  }

  openModal(targetModal: any, data: any, title: string) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });

    this.modeltitle = title;
    this.detail = { ...data };
  }

  onSubmit() {
    if (this.detail?._id) {
      this.updateDonation();
    } else {
      this.addDonation();
    }
  }

  addDonation() {
    const payload = {
      charityName: this.detail.charityName,
      charityDescription: this.detail.charityDescription,
      websiteLink: this.detail.websiteLink,
      donationPercentage: this.detail.donationPercentage,
      operator_id: this.userDetails._id,
    };

    this.apiCallingService.callAPI(payload, "POST", ConfigApi.URLS.DONATION_MASTER.CREATE)
      .subscribe(res => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success("Donation added successfully");
          this.closeBtnClick();
          this.getDonationList();
        }
      });
  }

  updateDonation() {
    const payload = {
      charityName: this.detail.charityName,
      charityDescription: this.detail.charityDescription,
      websiteLink: this.detail.websiteLink,
      donationPercentage: this.detail.donationPercentage,
      operator_id: this.userDetails._id,
    };

    this.apiCallingService.callAPI(
      payload,
      "PUT",
      ConfigApi.URLS.DONATION_MASTER.UPDATE + `/${this.detail._id}`
    ).subscribe(res => {
      if (this.apiCallingService.handleSuccess(res)) {
        this.toastr.success("Donation updated successfully");
        this.closeBtnClick();
        this.getDonationList();
      }
    });
  }

  openDeleteModal(deleteModal: any, donationId: string) {
    this.donationToDelete = donationId;
    this.modalService.open(deleteModal, { centered: true, backdrop: 'static', size: 'md' });
  }

  confirmDelete() {
    this.apiCallingService.callAPI(
      {},
      "DELETE",
      ConfigApi.URLS.DONATION_MASTER.DELETE + `/${this.donationToDelete}`
    ).subscribe(res => {
      if (this.apiCallingService.handleSuccess(res)) {
        this.toastr.success("Donation deleted successfully");
        this.closeDeleteModalClick();
        this.getDonationList();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.getDonationList();
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    this.detail = {};
  }

  closeDeleteModalClick() {
    this.modalService.dismissAll();
    this.donationToDelete = '';
  }
}
